<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  <div class="to-left d-flex align-items-center" style="gap: 10px;">
    <button
      nz-button
      nzType="primary"
      (click)="openAddLabel()"
      >
      <i nz-icon nzType="plus-circle" nzTheme="outline"></i>
      Etikett hinzufügen
    </button>

    <button
      nz-button
      nzType="default"
      (click)="regenerateArticleLabels()"
      >
      <i nz-icon nzType="reload" nzTheme="outline"></i>
      Alle Etiketten neu laden
    </button>

    <button
      nz-button
      nzType="default"
      (click)="printAllLabels()"
      >
      <i nz-icon nzType="printer" nzTheme="outline"></i>
      Alle Etiketten drucken
    </button>
  </div>
  <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
</app-table-header>

<nz-table appColumnLayout id="article-labels-list-table"
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: tableMaxWidth }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="article-etiketten-table"
  >
  <thead>
    <tr>
      <th nzColumnKey="variantName" [nzSortFn]="true">Variante</th>
      <th nzColumnKey="ean" [nzSortFn]="true">EAN</th>
      <th nzColumnKey="etikettenartName" [nzSortFn]="true">Etikettenart</th>
      <th nzColumnKey="status" [nzSortFn]="true">Status</th>
      <th nzColumnKey="lastPrinted" [nzSortFn]="true">Zuletzt gedruckt</th>
      <th nzColumnKey="actions" nzRight nzWidth="210px"></th>
    </tr>
  </thead>
  <tbody>
    @for (row of data.results; track row.rowKey) {
      <tr>
        <td>{{ row.variantName }}</td>
        <td>{{ row.ean }}</td>
        <td>{{ row.etikettenartName }}</td>
        <td>{{ row.status }}</td>
        <td>{{ row.lastPrinted ? (row.lastPrinted | dateFormat) : '—' }}</td>
        <td nzRight>
          <div class="actions">
            @if (canPreview(row)) {
              <span>
                <i
                  nz-icon
                  nzType="eye"
                  nz-tooltip
                  nzTooltipTitle="Vorschau"
                  nzTheme="outline"
                  (click)="preview(row)"
                ></i>
              </span>
            }
            @if (row.canCreate) {
              <button nz-button nzType="primary" nzSize="small" (click)="anlegen(row)">
                anlegen
              </button>
            }
            @if (row.canEdit && !row.canCreate) {
              <span>
                <i
                  nz-icon
                  nzType="edit"
                  nz-tooltip
                  nzTooltipTitle="Bearbeiten"
                  nzTheme="outline"
                  (click)="edit(row)"
                ></i>
              </span>
            }
            @if (row.labelKey) {
              <span>
                <i
                  appOpenPdf
                  [key]="row.labelKey"
                  nz-icon
                  nzType="printer"
                  nz-tooltip
                  nzTooltipTitle="Drucken"
                  nzTheme="outline"
                ></i>
              </span>
            }
            @if (isPersistedArticleLabel(row)) {
              <span>
                <i
                  nz-icon
                  nzType="delete"
                  nz-popconfirm
                  nzPopconfirmTitle="Sind Sie sicher?"
                  nzTheme="outline"
                  (nzOnConfirm)="deleteLabel(row)"
                  nz-tooltip
                  nzTooltipTitle="Etikett löschen"
                ></i>
              </span>
            }
            @if (canRegenerate(row)) {
              <span>
                <i
                  nz-icon
                  nzType="reload"
                  nzTheme="outline"
                  (click)="regenerateLabel(row)"
                  nz-tooltip
                  nzTooltipTitle="Etikett neu laden"
                ></i>
              </span>
            }
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
<app-etikett-preview-modal #etikettPreviewModalComponent></app-etikett-preview-modal>
